$(document).ready(function() {
    $('#logo').on('change', previewFile);
});

function previewFile() {
    var preview = document.getElementById('logo-preview');
    var file = document.getElementById('logo').files[0];
    var reader = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    };

    if (file) {
        reader.readAsDataURL(file);
        $('#logo-preview').parent().show();
    }
    else {
       preview.src = "";
        $('#logo-preview').parent().hide();
    }
}